import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';
import { ParallelSplitMapping } from './parallel-split-mapping';

/**
 * Configuration for a ParallelSplit task — forks the current payload into multiple
 * simultaneous branches. The payload is deep-copied and dispatched to each branch
 * concurrently. A downstream ParallelJoin is only needed if the branch results
 * need to be combined. If successMappingID is also set on the task, that becomes
 * an additional branch.
 */
export class ParallelSplitConfig extends DestinationTaskConfigBase {
	/**
	 * Array of branch definitions. Each entry holds a successMappingID resolved by the
	 * flow engine to the first task in that branch.
	 * @default []
	 */
	parallelSplitMappings: ParallelSplitMapping[] = [];

	constructor(init?: Partial<ParallelSplitConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}

	override GetDestinationTasks(): string[] {
		const taskDestinations: string[] = super.GetDestinationTasks();
		this.parallelSplitMappings.forEach(split => {
			const temp = new ParallelSplitMapping(split);
			taskDestinations.push(...temp.GetDestinationTasks());
		});
		return taskDestinations;
	}
}
